export const dismissNudgeTooltip = "savlNe";
export const mailListNudgeMoreOptionsTooltip = "S_FMlb";
export const nudgeFormattedTextTemplate = "SAU_Dd";
export default {dismissNudgeTooltip,mailListNudgeMoreOptionsTooltip,nudgeFormattedTextTemplate};